import { Flex, Stat, StatArrow } from '@chakra-ui/react'
import React, { forwardRef, useCallback, useContext, useMemo } from 'react'
import { DataListContext } from '../../contexts/DataListContext'

export const ColumnHeaderText = forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode
    active?: boolean
  }
>(({ children, active }, ref) => (
  <Flex
    ref={ref}
    gap={1.5}
    lineHeight="10px"
    whiteSpace="nowrap"
    align="center"
    fontFamily="Hero-New"
    fontWeight={active ? 500 : 400}
    color={active ? 'gray.600' : 'gray.500'}
    _dark={{ color: active ? 'gray.100' : 'gray.300' }}>
    {children}
    {/* </Button> */}
  </Flex>
))

export const SortButton = forwardRef<
  HTMLDivElement,
  {
    sortKey: string
    noArrow?: boolean
    children?: React.ReactNode
    defaultDir?: 'asc' | 'desc'
    px?: number
  }
>(({ sortKey, children, noArrow, defaultDir, px = 1 }, ref) => {
  const { sortBy, sort } = useContext(DataListContext)
  const { field: currKey, order: dir } = sort ?? {}
  const active = useMemo(() => currKey === sortKey, [currKey, sortKey])
  const onClick = useCallback(() => sortBy(sortKey, defaultDir), [sortBy, sortKey, defaultDir])
  return (
    <Flex px={px} ref={ref} align="center" onClick={onClick} cursor="pointer">
      {/* <Button size='sm'  fontWeight={active ? 600 : 400} variant='unstyled'> */}
      <ColumnHeaderText active={active}>{children}</ColumnHeaderText>
      {!noArrow ? (
        <Flex
          justify="center"
          minW={active ? '30px' : 0}
          w={active ? '30px' : 0}
          transition="all 333ms"
          opacity={active ? 1 : 0}
          // overflow="hidden"
          align="center">
          <Stat>
            <StatArrow
              transition="width 333ms"
              width={3}
              height={3}
              ml={active ? 2 : 0}
              cursor="pointer"
              _hover={{ color: 'blackAlpha.900' }}
              color={active ? 'blackAlpha.800' : 'blackAlpha.600'}
              type={dir === 'desc' ? 'decrease' : 'increase'}
              _dark={{
                color: active ? 'gray.100' : 'gray.400',
              }}
            />
          </Stat>
        </Flex>
      ) : null}
    </Flex>
  )
})
